module.exports = __webpack_public_path__ + "img/20190925171502383.dc8c10ba.jpg";